export enum ECurrency {
  EUR = 'EUR',
  USD = 'USD',
}
